import React from "react";

import clsx from "clsx";

import { useUser } from "@components/user-context";
import { useUserAttributionSettings } from "@hooks/use-user-attribution-settings";

interface Props {
  onClick: () => void;
}

const textShadowStyle = {
  textShadow: "1px 1px 0px var(--v2-bg-primary, #FFF)",
};

export const ModelSelectButton = ({ onClick }: Props): JSX.Element => {
  const { user } = useUser();
  const { attributionModel, attributionWindow, accountingMode } =
    useUserAttributionSettings();

  const attributionModelLabel =
    user?.attributionMethodEnum.reactSelectOptions.find(
      (e) => e.value === attributionModel,
    )?.label ?? "Default Label";
  const isAccrual = accountingMode === "accrual";

  return (
    <button
      type="button"
      className={clsx(
        "group h-12 pl-1.5 pr-4 text-sm flex items-center gap-2 rounded-[100px] border leading-[14px]",
        {
          "bg-v2-highlight-information border-v2-light text-v2-action hover:bg-v2-primary":
            isAccrual,
          "bg-v2-highlight-notice border-v2-notice text-v2-action-positive hover:bg-v2-primary":
            !isAccrual,
        },
      )}
      onClick={onClick}
    >
      <div
        className={clsx(
          "w-9 h-9 rounded-full flex items-center justify-center drop-shadow-[0_0px_10px_rgba(0,0,0,0.1)]",
          "group-hover:bg-v2-primary",
          {
            "bg-v2-overlay-shadow-100": isAccrual,
            "bg-v2-glass-inverse": !isAccrual,
          },
        )}
      >
        {isAccrual ? (
          <i className="fa-regular fa-briefcase text-base text-v2-action"></i>
        ) : (
          <i className="fa-regular fa-sack-dollar text-base text-v2-action-positive"></i>
        )}
      </div>
      <div className="text-left">
        <div
          className="flex items-center gap-1.5 font-bold"
          style={textShadowStyle}
        >
          {isAccrual ? "Accrual Performance" : "Cash Snapshot"}
        </div>
        <div className="text-xs">
          {attributionModelLabel}{" "}
          {isAccrual && <span>({attributionWindow}d)</span>}
        </div>
      </div>
    </button>
  );
};
